import { render } from "./member-news.vue?vue&type=template&id=35378946"
import script from "./member-news.vue?vue&type=script&lang=js"
export * from "./member-news.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__